var fontSizes = [
    '11px',
    '14px',
    '16px',
    '18px',
    '20px',
    '22px',
    '24px',
    '26px',
    '28px',
    '30px',
    '32px',
    '34px',
    '36px',
    '38px',
    '40px',
    '44px',
    '48px',
    '64px',
    '96px', // 18
];
fontSizes.label = fontSizes[0];
fontSizes.xs = fontSizes[0];
fontSizes.sm = fontSizes[1];
fontSizes.md = fontSizes[2];
fontSizes.lg = fontSizes[4];
fontSizes.xl = fontSizes[6];
var bodySizes = {
    xl: [fontSizes[1], fontSizes[4], fontSizes[6], fontSizes[6]],
    lg: [fontSizes[1], fontSizes[3], fontSizes[4], fontSizes[4]],
    md: [fontSizes[1], fontSizes[1], fontSizes[2], fontSizes[2]],
    sm: [fontSizes[1], fontSizes[1], fontSizes[1], fontSizes[1]],
    xs: [fontSizes[0], fontSizes[0], fontSizes[0], fontSizes[0]],
    label: [fontSizes[0], fontSizes[0], fontSizes[0], fontSizes[0]],
};
var headingSizes = {
    xl: [fontSizes[9], fontSizes[9], fontSizes[12], fontSizes[12]],
    lg: [fontSizes[6], fontSizes[6], fontSizes[9], fontSizes[9]],
    md: [fontSizes[4], fontSizes[4], fontSizes[6], fontSizes[6]],
    sm: [fontSizes[3], fontSizes[3], fontSizes[4], fontSizes[4]],
    xs: [fontSizes[2], fontSizes[2], fontSizes[3], fontSizes[3]],
};
export { fontSizes, bodySizes, headingSizes };
//# sourceMappingURL=fontSizes.js.map